import request from '@/utils/request'

const getMadaBinList = () => {
  // return Promise.resolve({ data: ['506968', '457997', '406996', '449197'] })
  return request(
    {
      method: 'GET',
      trackingKey: 'checkout_get-mada-bins',
      path: '/checkout/get-mada-bins',
    },
    { options: { attachToken: false } }
  )
}

export { getMadaBinList }
